import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.625 11.125V5.875M0.625 5.875V2.18056C0.625 1.32145 1.30723 0.625 2.14881 0.625H6.625C7.30699 0.625 7.96104 0.901561 8.44327 1.39384C8.92551 1.88613 9.19643 2.55381 9.19643 3.25C9.19643 3.94619 8.92551 4.61387 8.44327 5.10616C7.96104 5.59844 7.30699 5.875 6.625 5.875H4.05357M0.625 5.875H4.05357M4.05357 5.875L9.19643 11.125M9.19643 11.125L12.625 14.625M9.19643 11.125L12.625 7.625M9.19643 11.125L5.76786 14.625",
      stroke: "currentColor",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }